import React from "react";
import "./Favorite.css";
import { Container } from "react-bootstrap";
import Slider from "react-slick";
import jira from "../../../Asset/favoriteIcons/jira.svg";
import trello from "../../../Asset/favoriteIcons/trello.svg";
import asana from "../../../Asset/favoriteIcons/asana.svg";
import clickUp from "../../../Asset/favoriteIcons/click-up.svg";
import slack from "../../../Asset/favoriteIcons/slack.svg";
import googleTeam from "../../../Asset/favoriteIcons/google-team.svg";
import mailchimp from "../../../Asset/favoriteIcons/mailchimp.svg";
import sendgrid from "../../../Asset/favoriteIcons/sendgrid.svg";
import docker from "../../../Asset/favoriteIcons/docker.svg";
import assembla from "../../../Asset/favoriteIcons/Assembla.svg";
import googleCloud from "../../../Asset/favoriteIcons/google-clouds.svg";
import bitBuc from "../../../Asset/favoriteIcons/bitbucket.svg";
import gitlab from "../../../Asset/favoriteIcons/gitlab.svg";
import jenkis from "../../../Asset/favoriteIcons/jenkis.svg";
import aws from "../../../Asset/favoriteIcons/aws.svg";
import git from "../../../Asset/favoriteIcons/git.svg";
import jira1 from "../../../Asset/favoriteIcons/jira (1).svg";
import swagger from "../../../Asset/favoriteIcons/swagger.svg";
import vscode from "../../../Asset/favoriteIcons/vs-code.svg";
import kubefedctl from "../../../Asset/favoriteIcons/kubefedctl.svg";

const FavoriteTool = () => {
  const tools = [
    jira,
    trello,
    asana,
    clickUp,
    slack,
    googleTeam,
    mailchimp,
    sendgrid,
    docker,
    assembla,
  ];

  const tools2 = [
    googleCloud,
    bitBuc,
    gitlab,
    jenkis,
    aws,
    git,
    jira1,
    swagger,
    vscode,
    kubefedctl,
  ];

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 8,
    slidesToScroll: 1,
    autoplay: true,
    speed: 4000,
    autoplaySpeed: 100,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 512,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const settings1 = {
    dots: false,
    infinite: true,
    slidesToShow: 8,
    slidesToScroll: 1,
    autoplay: true,
    speed: 4000,
    autoplaySpeed: 100,
    cssEase: "linear",
    rtl: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 512,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <section className="favorite-section">
        <Container>
          <div className="top-text-favorite">
            <h2>
              OUR FAVORITE <span>TOOLS</span>
            </h2>
          </div>
          <div className="parante-favorite-slider">
            <div className="slider-container favorite-slider">
              <Slider {...settings}>
                {tools.map((tool, index) => (
                  <div key={index}>
                    <img src={tool} alt={`tool-${index}`} />
                  </div>
                ))}
              </Slider>
            </div>
            <div className="slider-container favorite-slider mt-4">
              <Slider {...settings1}>
                {tools2.map((tool, index) => (
                  <div key={index}>
                    <img src={tool} alt={`tool-${index}`} />
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default FavoriteTool;
